"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboLocationNamesSummary = getComboLocationNamesSummary;
function getComboLocationNamesSummary(trips) {
    return trips
        .flatMap((trip, i) => {
        if (trip.destinationLocationName === trips[i + 1]?.originLocationName) {
            return [trip.originLocationName];
        }
        return [trip.originLocationName, trip.destinationLocationName];
    })
        .join(" → ");
}
//# sourceMappingURL=getComboLocationNamesSummary.js.map